"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookedOutFlight = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../Table/columns/actionsColumn/actionLayout");
const views = {
    mark: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:markBookedOutTitle', defaultMessage: 'Mark flight' })),
        iconName: 'lock-closed-circle',
        targetOption: 'mark',
    },
    unmark: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:unmarkBookedOutTitle', defaultMessage: 'Unmark flight' })),
        iconName: 'lock-open-circle',
        targetOption: 'unmark',
    },
};
exports.bookedOutFlight = (0, actionLayout_1.createActionLayout)([
    (state) => state === 'unmark' ? views.mark : views.unmark,
]);
//# sourceMappingURL=bookedOutFlight.js.map